/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Budget {
    getFixupPrototypeFunction() { return Budget.fixupPrototype; }

    static newInstance(model: Partial<Budget>): Budget {
        let obj = Object.assign(new Budget(), model);
        Budget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Budget>): Budget {
        if (!model) return null;
        return Budget.newInstance(<Budget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Budget) {
        if (!obj) return;

        models.Budget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Budget): boolean {
        Object.setPrototypeOf(obj, Budget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_amount === undefined) {
            this.budget_amount = 0;
        }
    }

    budget_period: string;

    budget_amount: number;

}
